import styled from 'styled-components';
import SvgIcon from '@components/SvgIcon';

export const IconHorizontal = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      fill={color}
      fillRule="evenodd"
      d="M15 1H9v14h6V1Zm-4 12V3h2v10h-2ZM7 1H1v14h6V1ZM3 13V3h2v10H3Z"
    />
  ),
})``;

export const IconVertical = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      fill={color}
      fillRule="evenodd"
      d="M15 15V9H1v6h14ZM3 11h10v2H3v-2Zm12-4V1H1v6h14ZM3 3h10v2H3V3Z"
    />
  ),
})``;

export const IconSplit = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      fill={color}
      fillRule="evenodd"
      d="M10 1V0H8v16h2v-1h5V1h-5Zm0 2v10h3V3h-3ZM7 15H1V1h6v2H3v10h4v2Z"
    />
  ),
})``;

export const IconOverlap = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <clipPath id="prefixuhHdFRWkUPsgDooLgi0yda">
          <rect width="16" height="16" rx="0" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefixuhHdFRWkUPsgDooLgi0yda)">
        <path
          fill={color}
          fillRule="evenodd"
          d="M.5 1.5v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1Zm13 12v-10a1 1 0 1 1 2 0v11a1 1 0 0 1-1 1h-11a1 1 0 1 1 0-2h10Zm-11-11h2.95L2.5 5.45V2.5Zm0 7.068V6.864L6.864 2.5h2.704L2.5 9.568Zm.483.932L10.5 2.983V5.5l-5 5H2.983Zm3.93 0L10.5 6.914V10.5H6.914Z"
        />
      </g>
    </>
  ),
})``;

export const IconLocked = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      fill={color}
      d="M10 6.5v-2a2 2 0 0 0-3.995-.15L6 4.5v2h4Zm2 2H4v5h8v-5Zm-8-3v-1a4 4 0 1 1 8 0v1c0 .346-.044.68-.126 1H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h.126A4.007 4.007 0 0 1 4 5.5Z"
    />
  ),
})``;

export const IconUnlocked = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      fill={color}
      d="M8 .5a4 4 0 0 1 4 3.999h-2l-.005-.148a2 2 0 0 0-3.99 0L6 4.5l-.001 2H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h.126A4.007 4.007 0 0 1 4 5.5v-1a4 4 0 0 1 4-4Zm4 8H4v5h8v-5Z"
    />
  ),
})``;
